import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container';
import InvoiceForm from "../components/InvoiceForm"
import { useTranslation } from 'react-i18next';
import { Select } from '../components/Select';
import OfferForm from '../components/OfferForm';
import { useLocation } from 'react-router-dom';


const CreateDocumentPage: React.FC = () => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<string | null>('invoice');
  const [title, setTitle] = useState<string>(t('createInvoice'));
  const location = useLocation();
  const { type } = location.state || {};

  useEffect(() => {
    if (type) {
      setSelected(type);
    }
  }, [type]);

  useEffect(()=>{    
    selected === 'invoice' ? setTitle(t('createInvoice')) : setTitle(t('createOffer'))
  }, [selected, t])

  const options = [
    { label: t('invoice'), value: "invoice" },
    { label: t('offer'), value: "offer" },
  ];

    return (
        <div className="d-flex flex-column align-items-center justify-content-center w-100">
            <Container>
                <h1>{title}</h1>                
                <Select
                    label={t('chooseDocumentType')}
                    options={options}
                    value={selected?? 'invoice'}
                    placeholder={t('select')}
                    onChange={(val) => setSelected(val)}
                    id="document-type"
                />
                {selected === 'invoice' ? <InvoiceForm /> : <OfferForm />}
                
            </Container>
        </div>
    )
}

export default CreateDocumentPage
